module.exports = __webpack_public_path__ + "static/media/uzuvrh_logo.d0694197.png";